import { Column, TABLE_ACTION, defaultColActionDef, defaultColDef, formatter } from '@qrios/frontend-library';

import { predefinedColumns } from '../../../../../common/table/columns';
import { withNullFallback } from '../../../../../../constants/helpers/utils';
// eslint-disable-next-line max-len
import SessionTypeColumnHeaderWithInfo from '../../../../../common/table/columns/custom-headers/ussdSessionType/sessionTypeColumnHeaderWithInfo';
import ussdSessionCloseReasonToString from '../../../../../../constants/ussdSessionCloseReasonsToString';

const ACTIONS = [TABLE_ACTION.INFO];

export const columns: Column[] = [
  {
    ...defaultColDef,
    field: 'id',
    headerName: 'Session Id',
    flex: 1,
    minWidth: 150
  },
  predefinedColumns.date({}),
  {
    ...defaultColDef,
    field: 'shortcode',
    headerName: 'Shortcode',
    flex: 0.8
  },
  {
    ...defaultColDef,
    field: 'msisdn',
    headerName: 'Phone number',
    flex: 1.5
  },
  {
    ...defaultColDef,
    field: 'operator',
    headerName: 'Operator',
    flex: 0.7
  },
  {
    ...defaultColDef,
    field: 'duration',
    headerName: 'Duration',
    flex: 0.7,
    valueFormatter: formatter.timeFormatter
  },
  {
    ...defaultColDef,
    field: 'sessionCloseReason',
    headerName: 'Session close reason',
    flex: 1.5,
    valueFormatter: value => {
      if (value.value === null || value.value === undefined) {
        return withNullFallback(value.value);
      }
      return ussdSessionCloseReasonToString(value.value as string);
    }
  },
  {
    ...defaultColDef,
    field: 'sessionType',
    renderHeader: SessionTypeColumnHeaderWithInfo,
    flex: 0.5,
    valueFormatter: value => withNullFallback(value.value)
  },
  {
    ...defaultColDef,
    field: 'sessionTag',
    headerName: 'Session Tag',
    flex: 1.2,
    valueFormatter: value => withNullFallback(value.value)
  },
  predefinedColumns.cost({}),
  defaultColActionDef(ACTIONS)
];
